/* True if the user setting to allow hovering on tooltips is enabled
 * VSO:3877410 ease of access settings will need to integrate with this */
var hoverableTooltipsPreference = false;
export var setHoverableTooltipsPreference = function (isEnabled) {
    hoverableTooltipsPreference = isEnabled;
};
export function getHoverableTooltipsPreference() {
    return hoverableTooltipsPreference;
}
//# sourceMappingURL=HoverableTooltipSettingsPreference.js.map